import { Typography, Grid } from '@mui/joy'
import { ParseKeys } from 'i18next'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import {
  diskTypeEnumOptions,
  rubberTypeEnumOptions,
} from '~/shared/config/constants'
import { WheelCodeEnum } from '~/shared/config/enums'
import { AutocompleteInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type WheelsProps = {
  loading: boolean
}

const configs: { label: ParseKeys; code: WheelCodeEnum }[] = [
  { label: 'form.front right', code: WheelCodeEnum.FRONT_RIGHT },
  { label: 'form.front left', code: WheelCodeEnum.FRONT_LEFT },
  { label: 'form.rear right', code: WheelCodeEnum.REAR_RIGHT },
  { label: 'form.rear left', code: WheelCodeEnum.REAR_LEFT },
]

export function Wheels({ loading }: WheelsProps) {
  const { t } = useTranslation()

  return (
    <Container>
      <ContainerTitle>{t('form.wheels')}</ContainerTitle>

      <Grid container spacing={2.5}>
        {configs.map(({ label, code }) => (
          <Fragment key={code}>
            <Grid xs={0.4}>
              <Typography>{t(label)}</Typography>
            </Grid>
            <Grid xs={5.6}>
              <AutocompleteInput
                options={rubberTypeEnumOptions}
                label='form.rubber'
                name={`wheels.${code}.rubberType`}
                readOnly
                skeletonShow={loading}
              />
            </Grid>
            <Grid xs={6}>
              <AutocompleteInput
                options={diskTypeEnumOptions}
                label='form.disk'
                name={`wheels.${code}.diskType`}
                readOnly
                skeletonShow={loading}
              />
            </Grid>
          </Fragment>
        ))}
      </Grid>
    </Container>
  )
}
